import { axiosInstance } from '../shared/services/axios-instance'
import * as endpoints from '../constants/api-constants'

export default class RedeemService {
  static postRedeem(competitionId, config) {
     
    return axiosInstance
      .post(endpoints.postConcourseParticipation, {competitionId}, config)
      .then(resp => resp.data)
  }
}
